import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar2024 from '../MathClub2023/components/Sidebar2024';
import Archive2022 from 'views/MathClub/components/Archive2022';


const Mathcca1to22024 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_archive_url: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url}/home/events-activities/association/MathClub/Mathcca1to2/1.webp`;
    const p2 = `${config.base_image_url}/home/events-activities/association/MathClub/Mathcca1to2/2.webp`;
    const p3 = `${config.base_image_url}/home/events-activities/association/MathClub/Mathcca1to2/3.webp`;
    const p4 = `${config.base_image_url}/home/events-activities/association/MathClub/Mathcca1to2/4.webp`;
    const p5 = `${config.base_image_url}/home/events-activities/association/MathClub/Mathcca1to2/5.webp`;
    const p6 = `${config.base_image_url}/home/events-activities/association/MathClub/Mathcca1to2/6.webp`;
    const p7 = `${config.base_image_url}/home/events-activities/association/MathClub/Mathcca1to2/7.webp`;

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 2,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 2,
            cols: 1,
        },
        {
            src: p7,
            source: p7,
            rows: 1.5,
            cols: 1,
        },


    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                    Creating a Robot using 3D Solid Shapes
                                </Typography>
                                <br></br>
                                {/* <Typography variant='h7' align='justify' >
                                    Class 3: Character creation using tangrams (Story telling)
                                    <br></br>
                                    Class 4: Character creation using tangrams (Role Play: Healthy and unhealthy)
                                    <br></br>
                                    Class 5: Character creation using tangrams (Puppet Show)
                                </Typography> */}
                                <Typography
                                    variant={'h5'}
                                    color={'primary'}
                                    align={'center'}
                                    fontWeight={'normal'}
                                ><br />
                                    “The more you push yourself in extracurricular endeavors, the more you'll develop these skills”
                                    <br />
                                </Typography>

                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Classes: 1 and 2   Date: 25 October 2024
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                    In the final round of Math CCA, Grade 1 and 2 students actively and enthusiastically participated in
                                    creating robot models using 3D shapes such as cubes, spheres, cylinders, and cones.
                                    <br></br>
                                    participated in
                                    creating robot models using 3D shapes such as cubes, spheres, cylinders, and cones. This hands-on
                                    activity helped them recognize and understand basic shapes while promoting creativity and teamwork.
                                    <br></br>
                                    Each group designed a unique robot and presented their work in an insightful manner. This engaging
                                    approach reinforced shape identification and spatial skills in a fun and engaging way.
                                    <br></br>
                                </Typography>
                            </Box>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box marginBottom={4}>
                            <Sidebar2024 />
                        </Box>
                        <Box marginBottom={4}>
                            <Archive2022 />
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Mathcca1to22024;